import { useEffect } from 'react'

export const useCertificateScaling = () => {
  useEffect(() => {
    const updateCertificateScaling = () => {
      // Only apply on mobile devices
      if (window.innerWidth > 992) return

      const certificates = document.querySelectorAll('#certificate-page-1, #certificate-page-2')
      const desktopWidth = 928
      const padding = 24 // 12px on each side

      certificates.forEach((certificate) => {
        const element = certificate as HTMLElement
        if (element) {
          // Calculate optimal scale factor based on actual viewport width
          const availableWidth = window.innerWidth - padding
          let scaleFactor = availableWidth / desktopWidth

          // Apply more conservative scaling for iPhone sizes to ensure no clipping
          if (window.innerWidth <= 428) {
            // iPhone Pro Max and smaller - be very conservative
            scaleFactor = Math.min(scaleFactor * 0.95, 0.38) // Add 5% safety margin and cap at 0.38
          } else if (window.innerWidth <= 768) {
            // Tablet sizes
            scaleFactor = Math.min(scaleFactor * 0.98, 0.85) // Add 2% safety margin
          } else {
            scaleFactor = Math.min(scaleFactor, 1)
          }

          // Apply the calculated scale
          element.style.setProperty('--dynamic-scale-factor', scaleFactor.toString())

          // For Safari specifically, also set the transform directly
          const isSafari = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')
          if (isSafari) {
            element.style.transform = `scale(${scaleFactor})`
            element.style.webkitTransform = `scale(${scaleFactor})`
            element.style.marginLeft = `${(desktopWidth * scaleFactor) / -2}px`
            element.style.height = `${640 * scaleFactor}px`

            // Ensure the element doesn't exceed viewport bounds
            element.style.maxWidth = `${window.innerWidth - padding}px`
            element.style.overflow = 'visible'
          }
        }
      })
    }

    // Update on load and resize
    updateCertificateScaling()
    window.addEventListener('resize', updateCertificateScaling)
    window.addEventListener('orientationchange', updateCertificateScaling)

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateCertificateScaling)
      window.removeEventListener('orientationchange', updateCertificateScaling)
    }
  }, [])
}
